import { useEffect, useState } from "react"

const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== "undefined") {
      return window.matchMedia(query).matches
    }
    return false
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)

    setMatches(mediaQuery.matches)

    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    mediaQuery.addEventListener("change", handleChange)

    return () => {
      mediaQuery.removeEventListener("change", handleChange)
    }
  }, [query])

  return matches
}

const useSm = () => useMediaQuery("(min-width: 640px)")
const useMd = () => useMediaQuery("(min-width: 768px)")
const useLg = () => useMediaQuery("(min-width: 1024px)")
const useXl = () => useMediaQuery("(min-width: 1280px)")
const use2xl = () => useMediaQuery("(min-width: 1536px)")

export const tailwindBreakpoints = {
  sm: useSm,
  md: useMd,
  lg: useLg,
  xl: useXl,
  "2xl": use2xl,
}
